import { render, staticRenderFns } from "./PrimaryNavItemWithTitle.vue?vue&type=template&id=c5a50ac8&"
import script from "./PrimaryNavItemWithTitle.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItemWithTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports